import Image1 from '../../assets/project1.jpg'


const data = [
    {
        id: 1,
        category: 'Back-End',
        image: Image1,
        title: "Web-Scraping Project (Back-End)",
        desc: "This project involves scraping the ATP (Association of Tennis Professionals) website to retrieve the ATP 100 rankings for each week.",
        // demo: '',
        github: 'https://github.com/stplato/Web_Scraping'
    }
    /*Insert Any other project below*/
]


export default data